<td class="w-1/5">{{ Name }}</td>
<td class="w-1/5">{{ value }}</td>
<td class="w-1/5">{{ getOK() }}</td>
<td class="w-1/5" *ngIf="gg && !isEitherLMPDataMissing">{{ gg }}%</td>
<td class="w-1/5" *ngIf="ggfig && !isEitherLMPDataMissing">{{ ggfig }}</td>
